import React from 'react';
import { DragDropContext, DropResult, ResponderProvided } from 'react-beautiful-dnd';
import { reorder, move } from '../config';
import { DragDropProps } from '../interface';

const DragDrop: React.FC<DragDropProps> = ({ children, onDragEnd, ...rest }) => {
  /** 对拖拽进行基础判断 */
  const handleDragEnd = (result: DropResult, provided: ResponderProvided) => {
    const { source, destination } = result;
    if (!result.destination) {
      return;
    }

    if (source.index === destination?.index && source.droppableId === destination?.droppableId) {
      return;
    }
    onDragEnd(result, provided, { reorder, move });
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd} {...rest}>
      {children}
    </DragDropContext>
  );
};

export default DragDrop;
